import React from 'react';
import { IconLockSquareRoundedFilled } from '@tabler/icons-react';
import { usePropertyReadOnly } from '../shared/hooks/usePropertyReadOnly';
import AdminLayout from '../layouts/AdminLayout';

interface RequirePropertyActiveProps {
    children: React.ReactNode;
}

/**
 * Route-level stop for modules whose sidebar menu item is disabled while
 * the active property is inactive (Channel Setup, Message, Reviews,
 * iCalendar, Dynamic Pricing) — so a bookmark or typed-in URL can't bypass
 * a hidden/disabled menu entry.
 *
 * Deliberately does NOT redirect to /forbidden — that page means "you lack
 * permission", a different and confusing message here. Renders an in-place
 * "module unavailable" panel instead, still inside AdminLayout so the
 * sidebar/navbar stay usable (staff can navigate to Property Management to
 * reactivate).
 */
const RequirePropertyActive: React.FC<RequirePropertyActiveProps> = ({ children }) => {
    const { isReadOnly, propertyName } = usePropertyReadOnly();

    if (!isReadOnly) {
        return <>{children}</>;
    }

    return (
        <AdminLayout>
            <div className="container-fluid mt-5">
                <div className="d-flex flex-column align-items-center justify-content-center text-center py-5">
                    <IconLockSquareRoundedFilled size={48} className="text-warning mb-3" />
                    <h4>This module is unavailable</h4>
                    <p className="text-muted">
                        {propertyName} is currently inactive, so this feature is turned off until it's reactivated.
                    </p>
                </div>
            </div>
        </AdminLayout>
    );
};

export default RequirePropertyActive;
